<template>
  <!-- eslint-disable vue/no-v-html -->
  <v-container
    v-if="loading || coach.profile.experience"
    class="py-0"
  >
    <v-row class="pa-10">
      <div class="title mb-6">
        <span class="brandFont font-weight-bold">Professional Experience</span>
      </div>
      <v-skeleton-loader
        v-if="loading"
        width="700"
        type="paragraph"
      />
      <div
        v-else
        id="expRender"
        class="brandFont fiveHundred ql-editor px-0"
        style="width: 100%; font-size: 14px;"
        v-html="coach.profile.experience"
      >
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Section4',

  props: {
    coach: {
      type: Object,
      default: null,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
  #expRender {
    &.ql-editor {
      * {
        word-break: break-word !important;
        white-space: normal !important;
        color: black !important;
      }
    }
  }
</style>
